<app-breadcrumbs title="{{ 'MENU.ADMINISTRATION.UNIT_OF_MEASUREMENTS' | translate }}" ></app-breadcrumbs>

<div class="row">
    <dx-data-grid
        class="col-12"
        id="gridListData"
        [dataSource]="gridListData"
        keyExpr="id"
        [showRowLines]="true"
        [showBorders]="true"
        [columnAutoWidth]="true"
        (onRowInserting)="onRowInserting($event)"
        (onRowUpdated)="onRowUpdated($event)"
        (onRowRemoving)="onRowRemoving($event)"
>
        <dxo-editing
            mode="row"
            [allowUpdating]="true"
            [allowDeleting]="true"
            [allowAdding]="true">
        </dxo-editing>
        
        <dxi-column dataField="code" dataType="string" sortOrder="asc" [allowFiltering]="true" [allowSorting]="true" [caption]="'SHARED.CODE' | translate"></dxi-column>
        <dxi-column dataField="name" dataType="string" [allowFiltering]="true" [allowSorting]="true" [caption]="'SHARED.NAME' | translate"></dxi-column>
        <dxi-column dataField="description" dataType="string" [allowFiltering]="true" [allowSorting]="true" [caption]="'SHARED.DESCRIPTION' | translate"></dxi-column>
        <dxi-column dataField="increment" dataType="number" [allowEditing]="true" [allowFiltering]="true" [allowSorting]="true" [caption]="'SHARED.INCREMENT' | translate"></dxi-column>
        <dxi-column *ngIf="authService.userType == 'SYSTEM'" dataField="companyId" [filterOperations]= "['=']" dataType="string" [allowFiltering]="true" [allowSorting]="false" [caption]="'COMPANIES.COMPANY' | translate"></dxi-column>
    </dx-data-grid>
</div>